module.exports = __webpack_public_path__ + "img/cityApplyen.6729ddc9.jpg";